import {createStore} from 'vuex'
import router from "@/router";
import httpClient from "@/API/HttpClient";
import {login} from "@/API/API";

export default createStore({
    state: {
        token: localStorage.getItem('token'),
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem('token', token);
        },
        REMOVE_TOKEN(state) {
            state.token = '';
            localStorage.removeItem('token')
        },
    },
    actions: {
        login({commit}, {UserName, Password}) {
            const params = new FormData()
            params.append('Grant_Type', 'password')
            params.append('Client_Id', 'TabarokManagemnet')
            params.append('Client_Secret', process.env.VUE_APP_CLIENT_SECRET)
            params.append('scope', "WebApi")
            params.append('UserName', UserName)
            params.append('Password', Password)

            return new Promise((resolve, reject) => {
                console.log("PROMISING")
                login(params)
                    .then(resp => {
                        commit('SET_TOKEN', resp.data.access_token)
                        httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.access_token
                        console.log("RESOLVING")
                        resolve()
                    })
                    .catch(() => {
                        console.log("REJECTING")
                        reject()
                    })
            });
        },
        logout({commit}) {
            commit('REMOVE_TOKEN')
            router.push('/login?reLogin=true')
        },
    },
    modules: {},
    getters: {
        isLoggedIn: state => state.token !== '',
        token: state => 'Bearer ' + state.token,
    }
})
